import React from "react"
import game from "wizards.png"

const Wizards = props => <img src={game} className="game" {...props} />

export default Wizards
